//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getIsBvModerationEnabled } from '@redux/selectors/getIsBvModerationEnabled';
import { getIsModeratorVibeViewEnabled } from '@redux/selectors/getIsModeratorVibeViewEnabled';

export const getIsManualModerationRejectEnabled = createSelector(
  [getIsBvModerationEnabled, getIsModeratorVibeViewEnabled],
  (isBvModerationEnabled, isModeratorVibeViewEnabled) =>
    isBvModerationEnabled && isModeratorVibeViewEnabled,
);
